import { ToolbarConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';

export const config = {
    id: ActionType.TEXT_FAST_STYLE,
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        style: {
            width: '156px',
        },
        preventHighlight: true,
    },
];
